import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const toggleStar = ({ jobAdID, starred }) =>
  starred
    ? axios.post(`/api/job_ads/${jobAdID}/star`)
    : axios.delete(`/api/job_ads/${jobAdID}/star`);

export const useToggleStar = ({ onSuccess, onError } = {}) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: toggleStar,
    onSuccess: (_, variables) => {
      if (onSuccess) onSuccess(variables);
    },
    onError: (error, variables) => {
      enqueueSnackbar(error?.response?.data?.error || error?.message || 'Some error occured', { variant: 'error' });
      if (onError) onError(variables);
    },
  });
};
